import React, { useState, useEffect, useRef, useMemo } from "react";
import "../../styles/pagelayout.scss";
import "./PartnerProfile.scss";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../components/sidebar/Sidebar";
import Navbar from "../components/header/NavBar";
import BreadCrumb from "../components/header/BreadCrumb";
import { GetUserProfile } from "../../API/endpoints/User";
import {
  GetPartnerServicesList,
  getConsultantsByPartnerID,
  getPartnerByID,
  updatePartner,
} from "../../API/endpoints/Partner";
import {
  GetPermissionsByRoleAndModuleID,
  GetRoleById,
} from "../../API/endpoints/RolesAndPermissions/Roles";
import AddIcon from "@mui/icons-material/Add";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Typography } from "@mui/material";
import Chip from "@mui/material/Chip";
import PartnerDropDown from "./PartnerDropDown";
import { useForm } from "react-hook-form";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Multiselect } from "multiselect-react-dropdown";
import PartnerProfileRequest from "./PartnerProfileRequest";
import PartnerEditMarket from "./PartnerEditMarket";
import PartnerTeamNew from "./PartnerTeamNew";
import { uploadPartnerFile } from "../../API/endpoints/Partner";
import { getPartnerFile } from "../../API/endpoints/Partner";
import { getFlagIcon, getPartnerStatusStyle } from "../../common/helpers";
import AssignConsultantModal from "./AssignConsultantModal";
import EmptyContent from "../components/empty/EmptyContent";
import ConfirmModal from "../components/Modal/ConfirmModal";
import ToastMessage from "../components/toasts/ToastMessage";
import { GetAllServices } from "../../API/endpoints/Discovery";
import { GetCategories } from "../../API/endpoints/Common";
import DocumentItem from "../components/documentItem/DocumentItem";
import { message, Tag } from "antd";

interface AssignedConsultant {
  market: any;
  consultant: any[];
}

const PartnerProfile = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  const [roleID, setRoleID] = useState<number>(0);
  const [partnerData, setPartnerData] = useState<any>({});
  const [consultantData, setConsultantData] = useState<any>([]);
  const [marketData, setMarketData] = useState<any>([]);
  const [documents, setDocuments] = useState<any>([]);
  const [selectedRegions, setSelectedRegions] = useState<any>([]);
  const [assignConsultants, setAssignConsultants] = useState<any>([]);
  const [flag, setFlag] = useState(false);
  const [allRegions, setAllRegions] = useState<any>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [partnerConsultants, setPartnerConsultants] = useState<any>([]);

  const [categoriesList, setCategoriesList] = useState<any[]>([]);

  const [openRequestCallModal, setOpenRequestCallModal] = useState<any>("");
  const [notification, setNotification] = useState({ type: "", msg: "" });
  const [openEditMarket, setOpenEditMarket] = React.useState<any>({});

  const [permissionsList, setPermissionsList] = useState({
    basicInfo: false,
    team: false,
    serviceCapabilities: false,
    keyTerms: false,
    files: false,
    assignTeam: false,
  });

  useEffect(() => {
    setUserID(Cookies.get("userID"));
  }, []);

  function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }
  const [open, setOpen] = React.useState(false);
  // const [openMarket, setOpenMarket] = React.useState(false);
  // const handleCloseMarket = () => setOpen (false);

  const handleClickOpenMarket = () => {
    setOpen(true);
  };
  const handleCloseMarket = () => {
    setOpen(false);
  };
  const [age, setAge] = React.useState("");

  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value);
  };
  function stringAvatar(name: string) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    };
  }

  function handleAddIconClick() {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  }

  const fetchDocumentList = () => {
    (async () => {
      try {
        let mandatoryDocs = [];
        if (partnerData) {
          if (partnerData?.company_overview) {
            mandatoryDocs.push({
              file_name: "Company Overview",
              path: partnerData.company_overview,
            });
          }
          if (partnerData?.client_portfolio) {
            mandatoryDocs.push({
              file_name: "Client Portfolio",
              path: partnerData.client_portfolio,
            });
          }
          if (partnerData?.draft_agreements) {
            mandatoryDocs.push({
              file_name: "Draft Agreements",
              path: partnerData.draft_agreements,
            });
          }
        }
        const response = await getPartnerFile(partnerData?.id);
        setDocuments([...mandatoryDocs, ...response.data]);
      } catch (error) {}
    })();
  };

  async function handleUploadDocument(event: any) {
    const file = event.target.files[0];

    if (!file) return;

    const maxSize = 2 * 1024 * 1024;
    if (file.size > maxSize) {
      message.error("File size exceeds 2MB limit.");
      return;
    }

    const data = new FormData();
    data.append("file", file);
    data.append("file_name", file.name);
    data.append("partner_id", partnerData?.id || "");
    data.append("service", "1");
    try {
      const response = await uploadPartnerFile(data);
      if (response.msg === "Documents uploaded successfully") {
        fetchDocumentList();
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setRoleID(response.data?.user_roles[0]?.roles.id);
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID, navigate]);

  useEffect(() => {
    (async () => {
      const roleDetails = await GetRoleById(roleID?.toString());

      if (roleDetails?.data?.type === "partner") {
        const response = await GetPermissionsByRoleAndModuleID(
          roleID.toString(),
          "12"
        );
        if (response) {
          if (response?.data[0]) {
            const subModules = response.data[0].sub_modules;

            setPermissionsList({
              basicInfo: Boolean(
                subModules
                  ?.find((item: any) => item?.sub_module_name === "Basic Info")
                  ?.permissions_actions?.find((p: any) => p?.name === "read")
                  ?.permission?.find((p: any) => p?.permission)?.permission
              ),
              team: Boolean(
                subModules
                  ?.find((item: any) => item?.sub_module_name === "Team")
                  ?.permissions_actions?.find((p: any) => p?.name === "read")
                  ?.permission?.find((p: any) => p?.permission)?.permission
              ),
              serviceCapabilities: Boolean(
                subModules
                  ?.find(
                    (item: any) =>
                      item?.sub_module_name === "Service Capabilities"
                  )
                  ?.permissions_actions?.find((p: any) => p?.name === "read")
                  ?.permission?.find((p: any) => p?.permission)?.permission
              ),
              keyTerms: Boolean(
                subModules
                  ?.find((item: any) => item?.sub_module_name === "Key Terms")
                  ?.permissions_actions?.find((p: any) => p?.name === "read")
                  ?.permission?.find((p: any) => p?.permission)?.permission
              ),
              files: Boolean(
                subModules
                  ?.find(
                    (item: any) => item?.sub_module_name === "File Management"
                  )
                  ?.permissions_actions?.find((p: any) => p?.name === "read")
                  ?.permission?.find((p: any) => p?.permission)?.permission
              ),
              assignTeam: Boolean(
                subModules
                  ?.find((item: any) => item?.sub_module_name === "Assign Team")
                  ?.permissions_actions?.find((p: any) => p?.name === "create")
                  ?.permission?.find((p: any) => p?.permission)?.permission
              ),
            });
          }
        }
      } else if (roleDetails?.data?.type === "administrative") {
        const response = await GetPermissionsByRoleAndModuleID(
          roleID.toString(),
          "4"
        );
        if (response) {
          if (response?.data[0]) {
            const subModules = response.data[0].sub_modules;

            setPermissionsList({
              basicInfo: Boolean(
                subModules
                  ?.find((item: any) => item?.sub_module_name === "Basic Info")
                  ?.permissions_actions?.find((p: any) => p?.name === "read")
                  ?.permission?.find((p: any) => p?.permission)?.permission
              ),
              team: Boolean(
                subModules
                  ?.find((item: any) => item?.sub_module_name === "Team")
                  ?.permissions_actions?.find((p: any) => p?.name === "read")
                  ?.permission?.find((p: any) => p?.permission)?.permission
              ),
              serviceCapabilities: Boolean(
                subModules
                  ?.find(
                    (item: any) =>
                      item?.sub_module_name === "Service Capabilities"
                  )
                  ?.permissions_actions?.find((p: any) => p?.name === "read")
                  ?.permission?.find((p: any) => p?.permission)?.permission
              ),
              keyTerms: Boolean(
                subModules
                  ?.find((item: any) => item?.sub_module_name === "Key Terms")
                  ?.permissions_actions?.find((p: any) => p?.name === "read")
                  ?.permission?.find((p: any) => p?.permission)?.permission
              ),
              files: Boolean(
                subModules
                  ?.find(
                    (item: any) => item?.sub_module_name === "File Management"
                  )
                  ?.permissions_actions?.find((p: any) => p?.name === "read")
                  ?.permission?.find((p: any) => p?.permission)?.permission
              ),
              assignTeam: Boolean(
                subModules
                  ?.find((item: any) => item?.sub_module_name === "Assign Team")
                  ?.permissions_actions?.find((p: any) => p?.name === "create")
                  ?.permission?.find((p: any) => p?.permission)?.permission
              ),
            });
          }
        }
      }
    })();
  }, [roleID]);

  useEffect(() => {
    (async () => {
      try {
        const response = await getPartnerByID(params.partnerId);
        console.log("res", response);
        setPartnerData(response.data);
        setMarketData(response.data.market);
        setConsultantData(response.data.user_partners);
      } catch (error) {}
      try {
        const res = await GetPartnerServicesList(params.partnerId);
      } catch (error) {}

      try {
        const consultants = await getConsultantsByPartnerID(params.partnerId);
        setPartnerConsultants(consultants.data.rows);
      } catch (error) {}
    })();
  }, [params, flag]);

  const reloadData = () => {
    (async () => {
      try {
        const response = await getPartnerByID(params.partnerId);
        setPartnerData(response.data);
        setMarketData(response.data.market);
        setConsultantData(response.data.user_partners);
      } catch (error) {}
      try {
        const res = await GetPartnerServicesList(params.partnerId);
      } catch (error) {}

      try {
        const consultants = await getConsultantsByPartnerID(params.partnerId);
        setPartnerConsultants(consultants.data.rows);
      } catch (error) {}
    })();
  };

  useEffect(() => {
    fetchDocumentList();
  }, [partnerData]);

  useEffect(() => {
    (async () => {
      try {
        const response = await GetCategories();
        setCategoriesList(
          response.data.map((item: any) => {
            return { ...item, id: item.display_name };
          })
        );
      } catch (error) {}
    })();
  }, []);


    const openLink = (link: string) => {
        const fullUrl = link.startsWith("http") ? link : `https://${link}`;
        window.open(fullUrl, "_blank", "noopener,noreferrer");
    }

  const breadcrumbData = [
    {
      name: "Partner Management",
      url: userProfile?.user_type === "partner" ? "" : "/PartnerManagement",
      active: false,
    },
    {
      name: partnerData?.name || "",
      // url: `/partner/${params.partnerId}`,
      active: true,
    },
  ];

  const closeRequestCallModal = () => {
    setOpenRequestCallModal(false);
  };
  const onConfirmCallRequest = () => {
    const reqData = {
      status: "CALL_REQUESTED",
    };

    updatePartner(reqData, openRequestCallModal)
      .then((res) => {
        setNotification({
          type: "success",
          msg: "Call Requested successfully",
        });
        closeRequestCallModal();
        reloadData();
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleCloseNotification = () => {
    setNotification({
      type: "",
      msg: "",
    });
  };

  const handleCloseEditMarket = () => {
    setOpenEditMarket({});
  };

  const onHandleSuccessEditMarket = () => {
    setFlag(!flag);
    handleCloseEditMarket();
  };

  return (
    <Container fluid className="pge-layout">
      <Row>
        <Col className="sidebar">
          <Sidebar active="partner" />
        </Col>
        <Col className="content-section">
          <Navbar userProfile={userProfile} />
          <BreadCrumb breadcrumbData={breadcrumbData} />

          <Container fluid className="partner-profile">
            <Row className="row-1">
              {/* <Col md={3} lg={3} className="col-profile">
                <img
                  className="img-fluid img-thumbnail profile-pic"
                  src="../images/noimage.jpg"
                  alt="profilepic"
                />
                <div className="name-status">
                  <span className="font16-medium gray-800 mr8px">
                    {partnerData.company_name}
                  </span>
                  <span
                    className={
                      partnerData?.status === "Activated"
                        ? "success-status font12-medium"
                        : "blue-status font12-medium"
                    }
                  >
                    {partnerData?.status}
                  </span>
                </div>
                {partnerData?.website && (
                  <div className="mt8px">
                    <img
                      className="mr6px"
                      width="16px"
                      height="16px"
                      src="../svgs/globe.svg"
                      alt="globe"
                    />
                    <a
                      className="font12-regular"
                      href={`https://${partnerData.website}`}
                      rel="noreferrer"
                      target="_blank"
                    >
                      {partnerData.website}
                    </a>
                  </div>
                )}
                {partnerData?.partner_categories?.length !== 0 && (
                  <div className="focus-cat mt16px">
                    {partnerData?.partner_categories?.map((item: any) => {
                      return (
                        <div key={item.id} className="cat">
                          <span className="font12-regular gray-600">
                            {item.categories.name}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </Col> */}
              {/* <Col className="col-basicinfo">
                <table>
                  <tbody>
                    <tr>
                      <td className="font12-regular gray-500">
                        Annual Revenue
                      </td>
                      <td className="font12-regular gray-500 cln">:</td>
                      <td className="font12-medium gray-800">
                        {partnerData?.revenue_of_cus
                          ? `$${partnerData?.revenue_of_cus}`
                          : "Empty"}
                      </td>
                    </tr>
                    <tr>
                      <td className="font12-regular gray-500">
                        Years of Experience
                      </td>
                      <td className="font12-regular gray-500 cln">:</td>
                      <td className="font12-medium gray-800">
                        {partnerData?.years_of_experiences?.name}
                      </td>
                    </tr>
                  </tbody>
                </table>
                {permissions[0]?.sub_modules[5]?.permissions_actions[1]
                  ?.permission[0]?.permission === true && (
                  <div>
                    <a
                      className="font12-regular"
                      href={`/partner-filesettings/${params.partnerId}`}
                      rel="noreferrer"
                    >
                      <span>Files </span>
                      <img src="../svgs/redirect.svg" alt="redirect" />
                    </a>
                  </div>
                )}
              </Col> */}
              <Col className="col-services" xs={12}>
                <Card
                  style={{
                    border: "none",
                    minHeight: "100px",
                    verticalAlign: "center",
                    borderRadius: "0px",
                  }}
                >
                  {
                    /* permissionsList.basicInfo ? ( */
                    <Grid
                      gap="2"
                      style={{ margin: "auto", padding: "0 16px" }}
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "13px",
                        }}
                      >
                        <Avatar
                          style={{
                            marginRight: "12px",
                            backgroundColor: "#EFF8FF",
                            color: "#0152FB",
                            fontSize: "14px",
                            fontWeight: 500,
                            alignItems: "center",
                          }}
                          {...stringAvatar("Sample New")}
                        />
                        <div
                          style={{
                            display: "flex",
                            alignItems: "end",
                            gap: "13px",
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <h6 className="partner_name">
                              {partnerData?.name}
                            </h6>
                            <div
                              className="partner_website flex mt-[4px] cursor-pointer hover:text-blue-800"
                              onClick={()=> openLink(partnerData.website)}
                            >
                              {partnerData?.website}
                              <span className="website_icon">
                                <img
                                  className="mr8px"
                                  src="../svgs/link.svg"
                                  alt="wesite-pin"
                                />
                              </span>
                            </div>
                          </div>
                          {/* <div
                            className={`${getPartnerStatusStyle(
                              partnerData?.status
                                ?.replace(/_/g, " ")
                                .toLowerCase()
                            )} partner_status m-0`}
                          >
                            {partnerData?.status
                              ?.replace(/_/g, " ")
                              .toLowerCase()}
                          </div> */}
                          <Tag className='capitalize rounded-[12px] font-[500]' bordered={false} color={getPartnerStatusStyle(
                              partnerData?.status
                                ?.replace(/_/g, " ")
                                .toLowerCase()
                            )}>{partnerData?.status
                              ?.replace(/_/g, " ")
                              .toLowerCase()}</Tag>
                        </div>
                        <div
                          className="bl-gray200 ms-5 ps-4 py-2"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <div
                            className="d-flex"
                            style={{
                              gap: "8px",
                            }}
                          >
                            <img
                              width="14px"
                              className="listicon"
                              src="../svgs/shop.svg"
                              alt="Singapore"
                            />
                            <Typography
                              sx={{
                                fontSize: "10px",
                                color: "#667085",
                                fontWeight: 400,
                              }}
                            >
                              {partnerData?.region?.name}
                            </Typography>
                          </div>
                          <div
                            className="d-flex"
                            style={{
                              gap: "8px",
                            }}
                          >
                            <img
                              width="14px"
                              className="listicon"
                              src="../svgs/marketing.svg"
                              alt="Singapore"
                            />
                            <Typography
                              sx={{
                                fontSize: "10px",
                                color: "#667085",
                                fontWeight: 400,
                              }}
                            >
                              {partnerData?.value_added_services?.join(",")}
                            </Typography>
                          </div>
                          <div
                            className="d-flex"
                            style={{
                              gap: "8px",
                            }}
                          >
                            <img
                              width="14px"
                              className="listicon"
                              src="../svgs/tag.svg"
                              alt="Singapore"
                            />
                            <Typography
                              sx={{
                                fontSize: "10px",
                                color: "#667085",
                                fontWeight: 400,
                              }}
                            >
                              {partnerData?.financial_assistance?.join(",")}
                            </Typography>
                          </div>
                          {/* <div
                            className="d-flex"
                            style={{
                              gap: "8px",
                            }}
                          >
                            <img
                              className="listicon"
                              src="../svgs/user-alternate.svg"
                              alt="Singapore"
                            />
                            <Typography
                              sx={{
                                fontSize: "10px",
                                color: "#667085",
                                fontWeight: 400,
                              }}
                            >
                              {partnerConsultants.length > 0
                                ? `${partnerConsultants[0]?.first_name} ${partnerConsultants[0]?.last_name}`
                                : ""}
                            </Typography>
                          </div> */}
                        </div>
                      </div>
                      {Object.keys(userProfile).length > 0 &&
                      userProfile.user_type !== "consultant" &&
                      userProfile?.user_type !== "partner" ? (
                        <Stack direction="row" spacing={2}>
                          {/* {permissionsList.assignTeam ? (
                            <Button
                              onClick={handleClickOpenMarket}
                              className="btn-primary12 adduser"
                            >
                              Assign Consultant
                            </Button>
                          ) : (
                            <></>
                          )} */}

                          <PartnerProfileRequest
                            partnerData={partnerData}
                            onRequestForCall={(id: string) =>
                              setOpenRequestCallModal(id)
                            }
                            reload={() => setFlag(!flag)}
                          />
                        </Stack>
                      ) : (
                        <></>
                      )}
                    </Grid>
                    /* ) : (
                    <></>
                  ) */
                  }
                </Card>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div style={{ width: "70%" }}>
                    {
                      /* permissionsList.serviceCapabilities ? ( */
                      marketData && marketData.length > 0 ? (
                        marketData.map((item: any) => {
                          return (
                            <Col
                              style={{
                                paddingRight: "0px",
                                width: "100%",
                              }}
                            >
                              <Accordion
                                sx={{
                                  marginTop: "10px",
                                  borderRadius: "4px",
                                  border: "1px solid #E4E7EC",
                                  boxShadow: "none",
                                }}
                                defaultExpanded
                              >
                                <AccordionSummary
                                  expandIcon={
                                    <ExpandMoreIcon
                                      sx={{
                                        pointerEvents: "auto",
                                      }}
                                    />
                                  }
                                  aria-controls="panel1-content"
                                  id="panel1-header"
                                  sx={{
                                    pointerEvents: "none",
                                  }}
                                >
                                  <div
                                    className="align-center fullwidth d-flex pl20px borderbottom"
                                    style={{ padding: "6px 12px" }}
                                  >
                                    {getFlagIcon(item?.country?.name)}
                                    <Typography className="mx-05">
                                      {item.country.name}
                                    </Typography>
                                    {item.service_capabilities != null ? (
                                      <Chip
                                        sx={{
                                          marginLeft: "5px",
                                        }}
                                        size="small"
                                        label={`${
                                          item.service_capabilities.length +
                                          " " +
                                          "Capabilities"
                                        }`}
                                      />
                                    ) : (
                                      <div></div>
                                    )}
                                    <div className="ml-auto pos">
                                      {userProfile?.user_type !== "partner" ? (
                                        <PartnerDropDown
                                          reload={reloadData}
                                          marketData={item}
                                          marketID={item?.id}
                                          partnerID={partnerData?.id}
                                          country={item?.country?.id}
                                          setOpenEditMarket={setOpenEditMarket}
                                        />
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Row className="row-input px-12">
                                    {item.service_capabilities != null ? (
                                      <Col sm={4} md={4} lg={4}>
                                        <Row className="my-3">
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#667085",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            Service Capabilities
                                          </Typography>
                                        </Row>
                                        {item?.service_capabilities.map(
                                          (service: any, index: number) => {
                                            return (
                                              <Row key={index} className="my-3">
                                                <Chip
                                                  sx={{
                                                    padding: "8px",
                                                    marginRight: "8px",
                                                    fontWeight: "400",
                                                    width: "auto",
                                                    background: "#F9FAFB",
                                                    borderRadius: "2px",
                                                    color: "#475467",
                                                    fontSize: "12px",
                                                  }}
                                                  size="small"
                                                  label={service}
                                                />
                                              </Row>
                                            );
                                          }
                                        )}
                                      </Col>
                                    ) : (
                                      <div></div>
                                    )}
                                    <Col sm={8} md={8} lg={8}>
                                      <Row className="my-3">
                                        <Col sm={4} md={4} lg={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#667085",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            Category Focus
                                          </Typography>
                                        </Col>
                                        <Col sm={1}>
                                          <Typography>:</Typography>
                                        </Col>
                                        <Col sm={6} md={7} lg={7}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#1D2939",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            {item?.categories?.map(
                                              (c: any, index: number) => {
                                                return (
                                                  <Row
                                                    key={index}
                                                    className="mb12px"
                                                  >
                                                    {c.focus_category} -{" "}
                                                    {c.sub_categories.join(
                                                      ", "
                                                    )}
                                                  </Row>
                                                );
                                              }
                                            )}
                                          </Typography>
                                        </Col>
                                      </Row>
                                      <Row className="my-3">
                                        <Col sm={4} md={4} lg={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#667085",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            Minimum Tenure
                                          </Typography>
                                        </Col>

                                        <Col sm={1}>
                                          <Typography>:</Typography>
                                        </Col>
                                        <Col sm={7} md={7} lg={7}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#1D2939",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            {item.minimum_tenure}
                                          </Typography>
                                        </Col>
                                      </Row>
                                      <Row className="my-3">
                                        <Col sm={4} md={4} lg={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#667085",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            Shipment Terms
                                          </Typography>
                                        </Col>

                                        <Col sm={1}>
                                          <Typography>:</Typography>
                                        </Col>
                                        <Col sm={7} md={7} lg={7}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#1D2939",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            {item.shipment_terms.join(", ")}
                                          </Typography>
                                        </Col>
                                      </Row>
                                      <Row className="my-3">
                                        <Col sm={4} md={4} lg={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#667085",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            Engagement Model
                                          </Typography>
                                        </Col>

                                        <Col sm={1}>
                                          <Typography>:</Typography>
                                        </Col>
                                        <Col sm={7} md={7} lg={7}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#1D2939",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            {item?.engagement_model.join(", ")}
                                          </Typography>
                                        </Col>
                                      </Row>
                                      <Row className="my-3">
                                        <Col sm={4} md={4} lg={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#667085",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            Payment Terms
                                          </Typography>
                                        </Col>

                                        <Col sm={1}>
                                          <Typography>:</Typography>
                                        </Col>
                                        <Col sm={7} md={7} lg={7}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#1D2939",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            {item.payment_terms.join(", ")}
                                          </Typography>
                                        </Col>
                                      </Row>
                                      <Row className="my-3">
                                        <Col sm={4} md={4} lg={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#667085",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            Exclusivity
                                          </Typography>
                                        </Col>

                                        <Col sm={1}>
                                          <Typography>:</Typography>
                                        </Col>
                                        <Col sm={7} md={7} lg={7}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#1D2939",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            {item.trading_terms}
                                          </Typography>
                                        </Col>
                                      </Row>
                                      <Row className="my-3">
                                        <Col sm={4} md={4} lg={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#667085",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            Trade and Marketing Investments
                                          </Typography>
                                        </Col>

                                        <Col sm={1}>
                                          <Typography>:</Typography>
                                        </Col>
                                        <Col sm={7} md={7} lg={7}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#1D2939",
                                              fontSize: "12px",
                                              padding: "4px",
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {item?.trade_marketing_investments?.toLowerCase()}
                                          </Typography>
                                        </Col>
                                      </Row>
                                      <Row className="my-3">
                                        <Col sm={4} md={4} lg={4}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#667085",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            Key Channel Coverages
                                          </Typography>
                                        </Col>

                                        <Col sm={1}>
                                          <Typography>:</Typography>
                                        </Col>
                                        <Col sm={7} md={7} lg={7}>
                                          <Typography
                                            sx={{
                                              fontWeight: "500",
                                              borderRadius: "2px",
                                              color: "#1D2939",
                                              fontSize: "12px",
                                              padding: "4px",
                                            }}
                                          >
                                            {item?.channel_coverage?.join(", ")}
                                          </Typography>
                                        </Col>
                                      </Row>
                                      {item?.service_capabilities?.includes(
                                        "Warehousing"
                                      ) && (
                                        <Row className="my-3">
                                          <Col sm={4} md={4} lg={4}>
                                            <Typography
                                              sx={{
                                                fontWeight: "500",
                                                borderRadius: "2px",
                                                color: "#667085",
                                                fontSize: "12px",
                                                padding: "4px",
                                              }}
                                            >
                                              Warehousing
                                            </Typography>
                                          </Col>

                                          <Col sm={1}>
                                            <Typography>:</Typography>
                                          </Col>
                                          <Col sm={7} md={7} lg={7}>
                                            <Typography
                                              sx={{
                                                fontWeight: "500",
                                                borderRadius: "2px",
                                                color: "#1D2939",
                                                fontSize: "12px",
                                                padding: "4px",
                                              }}
                                            >
                                              {item?.warehousing?.join(", ")}
                                            </Typography>
                                          </Col>
                                        </Row>
                                      )}
                                    </Col>
                                  </Row>
                                </AccordionDetails>
                                {item.remarks ? (
                                  <Col className="bt-gray200 mx-2 py-8">
                                    <Typography
                                      sx={{
                                        fontSize: "12px",
                                        color: "#667085",
                                        marginTop: "10px",
                                      }}
                                    >
                                      Remarks
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: "12px",
                                        color: "#667085",
                                      }}
                                    >
                                      {item.remarks || "NA"}
                                    </Typography>
                                  </Col>
                                ) : (
                                  <></>
                                )}
                              </Accordion>
                            </Col>
                          );
                        })
                      ) : (
                        <Col style={{ paddingRight: "0px", width: "100%" }}>
                          <div
                            style={{
                              paddingRight: "0px",
                              backgroundColor: "white",
                              height: "20rem",
                              width: "100%",
                              marginTop: "16px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                              boxShadow:
                                "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)",
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: "500",
                                borderRadius: "2px",
                                color: "#black",
                                fontSize: "12px",
                                padding: "4px",
                              }}
                            >
                              {/* No Market Found */}
                              <EmptyContent message="No Market Found" />
                            </Typography>
                          </div>
                        </Col>
                      )
                      /* ) : (
                      <></>
                    ) */
                    }
                  </div>
                  <div style={{ width: "30%" }}>
                    <Col style={{ marginTop: "16px", width: "100%" }}>
                      {
                        /* permissionsList.team ? ( */
                        <PartnerTeamNew
                          partnerData={partnerData}
                          disableEdit={userProfile?.user_type === "partner"}
                          disableAdd={partnerData?.status !== "INVITED"}
                        />
                        /* ) : (
                        <></>
                      ) */
                      }

                      {
                        /* permissionsList.files ? ( */
                        <Card
                          style={{
                            marginTop: "9px",
                            padding: "10px 16px",
                            verticalAlign: "center",
                            borderRadius: "2px",
                            background: "#FFF",
                            borderColor: "white",
                            boxShadow:
                              "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)",
                          }}
                        >
                          <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="flex-start"
                          >
                            <Stack
                              sx={{
                                color: "#1D2939",
                                fontSize: "14px",
                                fontWeight: "500",
                                lineHeight: "20px",
                              }}
                            >
                              Documents
                            </Stack>
                            <Button
                              style={{
                                width: "20px",
                                padding: "0",
                                maxHeight: "20px",
                                textAlign: "center",
                                lineHeight: "20px",
                              }}
                              // onClick={handleClickl}
                              className="badgepill-blue50  blue-text br-0 bold no-border align-center"
                            >
                              <input
                                type="file"
                                accept="application/pdf"
                                style={{ display: "none" }}
                                ref={fileInputRef}
                                onChange={handleUploadDocument}
                              />

                              <AddIcon
                                sx={{
                                  fontSize: "19px",
                                  fontWeight: "500",
                                  alignItems: "center",
                                }}
                                onClick={handleAddIconClick}
                              />
                            </Button>
                          </Grid>
                          <Grid
                            sx={{
                              marginTop: "16px",
                              display: "flex",
                              flexDirection: "column",
                              gap: "15px",
                            }}
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="flex-start"
                          >
                            {documents && documents.length > 0 ? (
                              documents.map((item: any) => (
                                <DocumentItem
                                  name={item?.file_name}
                                  path={item?.path}
                                />
                              ))
                            ) : (
                              <div
                                style={{
                                  paddingRight: "0px",
                                  backgroundColor: "white",
                                  height: "5rem",
                                  width: "100%",
                                  marginTop: "20px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontWeight: "500",
                                    borderRadius: "2px",
                                    color: "#black",
                                    fontSize: "12px",
                                    padding: "4px",
                                  }}
                                >
                                  No Document found
                                </Typography>
                              </div>
                            )}
                          </Grid>
                        </Card>
                        /* ) : (
                        <></>
                      ) */
                      }
                    </Col>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
      <AssignConsultantModal
        open={open}
        handleCloseMarket={handleCloseMarket}
        params={params}
        consultantData={consultantData}
        reloadData={reloadData}
      />
      <PartnerEditMarket
        marketData={openEditMarket}
        open={Object.keys(openEditMarket).length > 0}
        onClose={handleCloseEditMarket}
        partnerID={partnerData?.id}
        onSuccess={onHandleSuccessEditMarket}
      />
      <ConfirmModal
        haveIcon={false}
        isModalOpen={Boolean(openRequestCallModal)}
        submit={onConfirmCallRequest}
        closeModal={closeRequestCallModal}
        submitBtnText="Confirm"
        cancelBtnText="Cancel"
        title="Confirm Call Request"
        bodyText="Are you sure you want to request for call ?"
      />
      <ToastMessage
        notification={notification}
        onCancel={handleCloseNotification}
      />
    </Container>
  );
};

export default PartnerProfile;
